import React from "react";
import { useUser } from "@/api/api";
import { hasPermission } from "@/user/user";

export const OnlyWithUserPermissionOrStaff = ({ children, permission }: { children: React.ReactNode, permission: string }) => {
  const { data: user, isLoading, isError } = useUser();
  if (!user || isLoading || isError) {
    return undefined;
  }
  const shouldShow = user.is_staff || hasPermission(user, permission);
  return shouldShow ? <>{children}</> : undefined;
};
